// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"checkbox_checkboxWrapper__SfHaq","customCheckbox":"checkbox_customCheckbox__TDeAH","label":"checkbox_label__RSvYC"};